import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import { FaArrowRightLong } from "react-icons/fa6";

const VisualGallery = () => {
  const navigate = useNavigate();
  const [images, setImages] = useState([]);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const res = await api({
          url: SummaryApi.getAllGallery.url,
          method: SummaryApi.getAllGallery.method,
        });

        const data = res?.data?.data || [];

        // ✅ only IMAGE
        const imageData = data
          .filter((item) => item.type === "IMAGE")
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // latest first
          .slice(0, 6); // only 6 images

        const formatted = imageData.map((item) => ({
          url: item.image?.url || item.thumbnail?.url,
        }));

        setImages(formatted);
      } catch (error) {
        console.log(error);
      }
    };

    fetchGallery();
  }, []);

  return (
<section className="w-full py-12 px-4 md:px-8 lg:px-16">
  <div className="max-w-5xl mx-auto text-center">

    <h2 className="text-4xl md:text-5xl mb-6 font-times text-black">
      Visual Gallery
    </h2>

    <p className="text-[#475569] text-sm max-w-2xl mx-auto mb-12">
      Experience the serene beauty of luxury estates nestled in the lush landscapes of Idukki, Kerala.
    </p>

            {/* DESKTOP */}
        {images.length >= 6 && (
          <div className="hidden md:flex justify-center gap-6">

            {/* LEFT */}
            <div className="flex flex-col gap-6 mt-10">
              <img src={images[0]?.url} alt="Gallery" className="rounded-2xl w-[260px] h-[260px] object-cover" />
              <img src={images[3]?.url} alt="Gallery" className="rounded-2xl w-[260px] h-[240px] object-cover" />
            </div>

            {/* CENTER */}
            <div className="flex flex-col gap-6">
              <img src={images[1]?.url} alt="Gallery" className="rounded-2xl w-[280px] h-[280px] object-cover" />
              <img src={images[4]?.url} alt="Gallery" className="rounded-2xl w-[280px] h-[280px] object-cover" />
            </div>

            {/* RIGHT */}
            <div className="flex flex-col gap-6 mt-10">
              <img src={images[2]?.url} alt="Gallery" className="rounded-2xl w-[260px] h-[260px] object-cover" />
              <img src={images[5]?.url} alt="Gallery" className="rounded-2xl w-[260px] h-[240px] object-cover" />
            </div>

          </div>
        )}

        {/* MOBILE */}
        <div className="grid grid-cols-2 gap-4 md:hidden">
          {images.map((img, i) => (
            <img
              key={i}
              src={img.url}
              alt="Gallery"
              className="rounded-2xl w-full h-[160px] object-cover"
            />
          ))}
        </div>

    {/* BUTTON FIX */}
    <div className="flex justify-center">
      <button
        onClick={() => navigate("/gallery")}
        className="mt-12 bg-[#45A301] hover:bg-[#3e9202] text-white px-10 py-3 rounded-lg flex items-center gap-2 transition shadow-md"
      >
        View Full Gallery
        <FaArrowRightLong />
      </button>
    </div>

  </div>
</section>
  );
};

export default VisualGallery;